<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="65%"
            height="100%"
            class="modalDialog"
            no-click-animation
          >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-card-actions class="cardWrap__scroll">
                      <v-container>
                      <v-form
                        class="cardWrap__fromArea"
                        ref="form"
                        :lazy-validation="lazy"
                        v-model="valid"
                      >
                        <v-row justify="space-around" v-if="changemode_status">
                          <div class="cardWrap__fromArea__title">メニューID</div>
                            <v-text-field
                              :disabled="changemode_status"
                              v-model="from_set_data.menu_id"
                              maxlength="10"
                              :rules="[rules.required]"
                              autofocus
                            />
                        </v-row>

                        <v-row justify="space-around">
                          <div class="cardWrap__fromArea__title">タイトル</div>
                            <v-text-field
                              v-model="from_set_data.title"
                              maxlength="128"
                              :rules="[rules.required]"
                            />
                        </v-row>

                        <v-row justify="space-around">
                            <div class="cardWrap__fromArea__title">親メニュー</div>
                            <v-col>
                                <v-select
                                    class="pr-4"
                                    :items="parent"
                                    item-value="id"
                                    item-text="title"
                                    v-model="from_set_data.parent_id"
                                    label="親メニュー"
                                    :disabled="childhas"
                                />
                            </v-col>
                        </v-row>

                        <v-row justify="space-around">
                          <div class="cardWrap__fromArea__title">外部URL</div>
                            <v-text-field
                              v-model="from_set_data.external_url"
                              maxlength="255"
                              placeholder="https://"
                            />
                            <v-checkbox v-model="from_set_data.external_link" class="mx-2" label="外部URL使用" />
                        </v-row>

                        <v-row justify="space-around">
                          <div class="cardWrap__fromArea__title">内部URL</div>
                            <v-text-field
                              v-model="from_set_data.url"
                              maxlength="255"
                              placeholder="/test"
                            />
                        </v-row>

                        <v-row justify="space-around">
                          <div class="cardWrap__fromArea__title">リンク名</div>
                            <v-text-field
                              v-model="from_set_data.name"
                              maxlength="128"
                            />
                        </v-row>

                        <v-row justify="space-around">
                          <div class="cardWrap__fromArea__title">アイコンクラス名</div>
                            <v-text-field
                              v-model="from_set_data.icon_class"
                              maxlength="128"
                            />
                        </v-row>

                        <v-row justify="space-around">
                            <div class="cardWrap__fromArea__title">表示会員クラス</div>
                            <div class="v-input">
                                <template v-for="val in member_class_list">
                                    <v-checkbox v-model="checke_member_class" :key="val.code" :value="val.code" class="ml-3" :label="val.code_name" />
                                </template>
                            </div>
                        </v-row>

                        <v-row justify="space-around">
                            <div class="cardWrap__fromArea__title">表示会員ステータス</div>
                            <div class="v-input">
                                <template v-for="val in member_status_list">
                                    <v-checkbox v-model="checke_member_status" :key="val.code" :value="val.code" class="ml-3" :label="val.code_name" />
                                </template>
                            </div>
                        </v-row>

                        <v-row justify="start">
                          <div class="cardWrap__fromArea__title" style="width: 200px;">サイドメニューに表示する</div>
                          <v-checkbox v-model="from_set_data.valid_flag" label="" />
                        </v-row>

                        <v-row justify="start">
                          <div class="cardWrap__fromArea__title" style="width: 200px;">メニューに表示する</div>
                          <v-checkbox v-model="from_set_data.futter_flag" label="" :disabled="childhas || disableFooterFlag"/>
                        </v-row>

                        <v-row justify="space-around">
                          <div class="cardWrap__fromArea__title">メニュータイトル</div>
                            <v-text-field
                              v-model="from_set_data.futter_title"
                              maxlength="20"
                              :disabled="childhas"
                            />
                        </v-row>

                      </v-form>
                      </v-container>
                    </v-card-actions>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                      <v-btn color="green darken-4" text v-if="addmode_status" @click="validateCheck">登録</v-btn>
                      <v-btn color="green darken-4" text v-if="changemode_status" @click="updateValidateCheck">変更</v-btn>
                    </v-card-actions>
                </v-card>
            </div>
            <AddOverlay
              page-name="メニュー"
              @processing="registerMenu"
              @cancel="addOverlay = !addOverlay"
              :process-result="process"
              :overlay-switch="addOverlay"
            />
            <ChangeOverlay
              page-name="メニュー"
              @processing="updateMenu"
              @cancel="changeOverlay = !changeOverlay"
              :process-result="process"
              :OverlaySwitch="changeOverlay"
            />
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '../../../../components/module/CardTitle';
import { GET_MENU_PARENT, REGISTER_MENU_MASTER, UPDATE_MENU_MASTER } from '../../../../constants/menu_master';
import { GET_CODE_LIST } from '@/constants/codelist';
import AddOverlay from '../overlay/AddOverlay';
import ChangeOverlay from '../overlay/ChangeOverlay';
import { InputPagesMixin } from './../mixin/InputPagesMixin';
import { CODE_MASTER } from '../../../config';

export default {
    components: {
        CardTitle,
        AddOverlay,
        ChangeOverlay
    },
    // マスタ管理で共通項目をMixinする ./mixin/InputPagesMixin.js
    mixins: [InputPagesMixin],
    props: ['editInfo'],
    data () {
        return {
            page_title: 'メニュー登録',
            // 親リスト
            parent: [],
            // 表示会員クラス
            member_class_list: [],
            // チェックした会員クラス
            checke_member_class: [],
            // 表示会員ステータス
            member_status_list: [],
            // チェックした会員ステータス
            checke_member_status: [],
            // 入力値
            from_set_data: {
                // メニューコード
                menu_id: '',
                title: '',
                parent_id: '',
                external_url: '',
                url: '',
                name: '',
                icon_class: '',
                display_member_class: '',
                display_member_status: '',
                sort_no: '',
                external_link: 0,
                // 有効フラグ
                valid_flag: 1,
                futter_flag: 0,
                futter_title: ''
            },
            // バリデーション
            lazy: true,
            rules: {
                required: value => !!value || this.$t('error.validation.required.any')
            },
            mode_status: ''
        };
    },
    created () {
        this.Initialize();
    },
    computed: {
        addmode_status () {
            return this.mode_status === 'addMode';
        },
        changemode_status () {
            return this.mode_status === 'changeMode';
        },
        // 子メニューあり
        childhas () {
            return this.editInfo.childhas;
        },
        disableFooterFlag () {
            return this.from_set_data.valid_flag === false;
        }
    },
    watch: {
        addOverlay () {
            if (this.addOverlay === false) {
                this.process.result = '';
            }
        },
        // mode_statusで表示を切り替える
        mode_status () {
            if (this.mode_status === 'addMode') {
                this.page_title = 'メニュー登録';
            } else if (this.mode_status === 'changeMode') {
                this.page_title = 'メニュー変更';
            }
        },
        // 親コンポーネント(MenuList.vue)から渡された値をinputに代入
        editInfo () {
            this.from_set_data.menu_id = this.editInfo.menu_id;
            this.from_set_data.title = this.editInfo.title;
            this.from_set_data.parent_id = this.editInfo.parent_id;
            this.from_set_data.external_url = this.editInfo.external_url;
            this.from_set_data.url = this.editInfo.url;
            this.from_set_data.name = this.editInfo.name;
            this.from_set_data.icon_class = this.editInfo.icon_class;
            this.from_set_data.display_member_class = this.editInfo.display_member_class;
            this.from_set_data.display_member_status = this.editInfo.display_member_status;
            this.from_set_data.sort_no = this.editInfo.sort_no;
            this.from_set_data.external_link = this.editInfo.external_link;
            this.from_set_data.valid_flag = this.editInfo.valid_flag;
            this.from_set_data.futter_flag = this.editInfo.futter_flag;
            this.from_set_data.futter_title = this.editInfo.futter_title;

            // 子メニューがあるか
            this.from_set_data.childhas = this.editInfo.childhas;

            // 表示会員クラスチェック
            if (this.from_set_data.display_member_class != null) {
                this.checke_member_class = this.from_set_data.display_member_class.split(',');
            } else {
                this.checke_member_class = [];
            }
            // 表示会員ステータスチェック
            if (this.from_set_data.display_member_status != null) {
                this.checke_member_status = this.from_set_data.display_member_status.split(',');
            } else {
                this.checke_member_status = [];
            }
        },
        /** ----------------------------------------------------------------
         * サイドメニューに表示しない場合、メニューのチェックを外す。
         * ----------------------------------------------------------------- */
        'from_set_data.valid_flag' (val) {
            if (val === false) {
                this.from_set_data.futter_flag = false;
            }
        }
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.addOverlay = false;
            this.changeOverlay = false;
            this.from_set_data = {
                menu_id: '',
                title: '',
                parent_id: '',
                external_url: '',
                url: '',
                name: '',
                icon_class: '',
                display_member_class: '',
                display_member_status: '',
                sort_no: '',
                external_link: 0,
                valid_flag: 1,
                futter_flag: 0,
                futter_title: ''
            };
            this.process = {
                result: '',
                result_text: ''
            };
            // 親一覧を取得
            this.getParentList();
            // 会員クラスを取得
            this.getClassCodeList();
            // 会員ステータスを取得
            this.getStatusCodeList();
            // 表示会員クラスチェック
            var list = [];
            for (let i = 0; i < this.member_class_list.length; i++) {
                list.push(this.member_class_list[i].code);
            }
            this.checke_member_class = list;
            // 表示会員ステータスチェック
            var listStatus = [];
            for (let i = 0; i < this.member_status_list.length; i++) {
                listStatus.push(this.member_status_list[i].code);
            }
            this.checke_member_status = listStatus;
        },
        btnclick () {
            this.$refs.input.click();
        },
        /** --------------------------------------------
         * 親メニューの一覧を取得
         *-------------------------------------------- */
        getParentList () {
            this.$apollo.query({
                query: GET_MENU_PARENT
            }).then(res => {
                // 初期値
                var parentList = {
                    id: null,
                    title: ''
                };
                var get = res.data.GetMenuParent;
                // マージ
                get.push(parentList);
                this.parent = get;
            }).catch(e => {
                this.error = e;
            });
        },
        /** --------------------------------------------
         * 表示会員クラスの一覧を取得
         *-------------------------------------------- */
        getClassCodeList () {
            this.$apollo.query({
                query: GET_CODE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    code_key: 'display_member_class',
                    default_display: 0
                }
            }).then(res => {
                var get = res.data.GetCodeList.CodeList;
                this.member_class_list = get;
            });
        },
        /** --------------------------------------------
         * 表示会員ステータスの一覧を取得
         *-------------------------------------------- */
        getStatusCodeList: async function () {
            await this.$apollo.query({
                query: GET_CODE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    code_key: 'member_status',
                    default_display: 0
                }
            }).then(res => {
                var get = [];
                get = res.data.GetCodeList.CodeList;

                // 既に初期値を設定済みかどうか確認
                var flg = true;
                for (let i = 0; i < get.length; i++) {
                    if (get[i].code === '0') {
                        flg = false;
                        break;
                    };
                }
                // 初期値追加
                if (flg === true) {
                    get.push({
                        'code': '0',
                        'code_key_name': '会員ステータス',
                        'code_name': '未登録',
                        'code_key': null,
                        'reserve1': null
                    });
                }

                this.member_status_list = get;
            });
        },
        /** ----------------------------------------------
         * 新規登録処理
         * ---------------------------------------------- */
        registerMenu: async function () {
            // 二重送信防止処理
            if (this.process.processing) return;
            this.process.processing = true;

            // ローディング
            this.$store.commit('loading/setIsLoading', true);

            // 表示メンバークラスをカンマ区切りで格納
            this.from_set_data.display_member_class = this.checke_member_class.join(',');
            this.from_set_data.display_member_status = this.checke_member_status.join(',');

            // API送信
            this.$apollo.mutate({
                mutation: REGISTER_MENU_MASTER,
                variables: {
                    UpdateMenuMaster: [{
                        title: this.from_set_data.title,
                        parent_id: this.from_set_data.parent_id,
                        external_url: this.from_set_data.external_url,
                        url: this.from_set_data.url,
                        name: this.from_set_data.name,
                        icon_class: this.from_set_data.icon_class,
                        display_member_class: this.from_set_data.display_member_class,
                        display_member_status: this.from_set_data.display_member_status,
                        external_link: this.from_set_data.external_link,
                        valid_flag: this.from_set_data.valid_flag,
                        futter_flag: this.from_set_data.futter_flag,
                        futter_title: this.from_set_data.futter_title
                    }]
                }
            }).then(res => {
                // ローディングオフ
                this.$store.commit('loading/setIsLoading', false);
                this.process.result = res.data.RegisterMenuMaster.result;
                if (this.process.result === 1) {
                    this.CloseModal();
                } else if (this.process.result === 2) {
                    this.process.result_text = this.$t('result.error.existsMenu');
                }
                this.process.processing = false;
            }).catch(error => {
                // ローディングオフ
                this.$store.commit('loading/setIsLoading', false);
                this.error = error;
                this.process.result = 0;
                this.process.result_text = this.$t('result.error.add');
                this.process.result = '';
                this.process.processing = false;
            });
        },
        /** ----------------------------------------------
         * 更新処理
         * ---------------------------------------------- */
        updateMenu: async function () {
            // 二重送信防止処理
            if (this.process.processing) return;
            this.process.processing = true;

            // ローディング
            this.$store.commit('loading/setIsLoading', true);

            // 表示会員をカンマ区切りで格納
            this.from_set_data.display_member_class = this.checke_member_class.join(',');
            this.from_set_data.display_member_status = this.checke_member_status.join(',');

            this.$apollo.mutate({
                mutation: UPDATE_MENU_MASTER,
                variables: {
                    UpdateMenuMaster: [{
                        menu_id: this.from_set_data.menu_id,
                        title: this.from_set_data.title,
                        parent_id: this.from_set_data.parent_id,
                        external_url: this.from_set_data.external_url,
                        url: this.from_set_data.url,
                        name: this.from_set_data.name,
                        icon_class: this.from_set_data.icon_class,
                        display_member_class: this.from_set_data.display_member_class,
                        display_member_status: this.from_set_data.display_member_status,
                        external_link: this.from_set_data.external_link,
                        valid_flag: this.from_set_data.valid_flag,
                        futter_flag: this.from_set_data.futter_flag,
                        futter_title: this.from_set_data.futter_title
                    }],
                    SortFlg: false
                }
            }).then(res => {
                // ローディングオフ
                this.$store.commit('loading/setIsLoading', false);
                this.process.result = res.data.UpdateMenuMaster.result;
                this.process.processing = false;
                this.CloseModal();
            }).catch(error => {
                // ローディングオフ
                this.$store.commit('loading/setIsLoading', false);
                this.error = error;
                this.process.result = 0;
                this.process.result_text = this.$t('result.error.change');
                this.process.result = '';
                this.process.processing = false;
            });
        },
        /** ----------------------------------------------
         * 登録ボタン押下
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.form.validate()) {
                if (Number(this.editInfo.menuCount + Number(this.from_set_data.futter_flag)) > Number(CODE_MASTER.MAX_DISPLAY_MENU_NUMBER)) {
                    alert('メニュー設定数の上限数(' + Number(CODE_MASTER.MAX_DISPLAY_MENU_NUMBER) + ')を超えています。');
                } else if (this.mode_status === 'addMode') {
                    this.addOverlay = true;
                } else if (this.mode_status === 'changeMode') {
                    this.changeOverlay = true;
                }
            }
        },
        updateValidateCheck () {
            if (this.editInfo.futter_flag === 0) {
                if (Number(this.editInfo.menuCount + Number(this.from_set_data.futter_flag)) > Number(CODE_MASTER.MAX_DISPLAY_MENU_NUMBER)) {
                    alert('メニュー設定数の上限数(' + Number(CODE_MASTER.MAX_DISPLAY_MENU_NUMBER) + ')を超えています。');
                } else {
                    this.changeOverlay = true;
                }
            } else {
                this.changeOverlay = true;
            }
        },
        /** ----------------------------------------------
         * モーダル画面を表示 './modal/MenuModal.vue'
        *  メニュー一覧より追加ボタン押下で呼び出し
         * ---------------------------------------------- */
        addModal () {
            this.Initialize();
            this.dialog = true;
            this.mode_status = 'addMode';
        },
        /** --------------------------------------------
        * モーダル画面を表示 './modal/MenuModal.vue'
        *  メニュー一覧より変更ボタン押下で呼び出し
        * -------------------------------------------- */
        editModal () {
            this.Initialize();
            this.dialog = true;
            this.mode_status = 'changeMode';
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.Initialize();
            this.$refs.form.resetValidation();
            this.$emit('refresh-event');
            this.dialog = false;
        }
    }
};
</script>
